export const GameDisplayHeight = 85;
